import { jsx as _jsx } from "react/jsx-runtime";
import Image from "next/image";
import { useConfig } from "../Config/ConfigContext";
import classNames from "classnames";
export const ParkImage = (props)=>{
    const { fill , className , size , ...rest } = props;
    const { imgixConfig  } = useConfig();
    const calculatedSize = {
        [ParkImageSize.Thumbnail]: [
            400,
            200
        ],
        [ParkImageSize.Background]: [
            1600,
            600
        ]
    }[size];
    return /*#__PURE__*/ _jsx(Image, {
        loader: (e)=>"https://".concat(imgixConfig.s3Domain, ".imgix.net/").concat(e.src, "?w=").concat(e.width, "&auto=compress"),
        loading: "eager",
        width: calculatedSize[0],
        height: calculatedSize[1],
        className: classNames(className, {
            "absolute top-0 left-0 w-full h-full": fill
        }),
        ...rest
    });
};
export var ParkImageSize;
(function(ParkImageSize) {
    ParkImageSize[ParkImageSize["Thumbnail"] = 0] = "Thumbnail";
    ParkImageSize[ParkImageSize["Background"] = 1] = "Background";
})(ParkImageSize || (ParkImageSize = {}));
